import React from 'react';
import Div from './div';

export default () => <Div setup='c around center' css='View' hView='90' vView='70' class='fBig marg pad fgWarn'>
    Na mobile treba stránku HKJ.SK otvárať v prehliadači ako Safari alebo Chrome.<br/><br/>
    Stránku si otvoril v Messengeri, tu však nefunguje.<br/><br/>
    Napíš hkj.sk do svojho prehliadača.<br/><br/>
</Div>
